(() => {
  if (window.sfNavigationInitialized) return;
  window.sfNavigationInitialized = true;
  const instances = new WeakMap();

  function initialize(header) {
    if (instances.has(header)) return;
    const controller = new AbortController();
    const options = { signal: controller.signal };
    instances.set(header, controller);
    const mobile = window.matchMedia("(max-width: 760px)");
    const nav = header.querySelector(".site-nav");
    const menuButton = header.querySelector(".mobile-menu-toggle");
    const disclosures = [];
    const closeMobile = (restoreFocus = false) => {
      nav.hidden = mobile.matches;
      menuButton.setAttribute("aria-expanded", "false");
      disclosures.forEach(({ close }) => close());
      if (restoreFocus) menuButton.focus();
    };
    menuButton.hidden = false;
    menuButton.addEventListener(
      "click",
      () => {
        const open = menuButton.getAttribute("aria-expanded") !== "true";
        menuButton.setAttribute("aria-expanded", String(open));
        nav.hidden = !open;
        if (!open) disclosures.forEach(({ close }) => close());
      },
      options,
    );
    header.querySelectorAll(".shop-disclosure").forEach((disclosure) => {
      const trigger = disclosure.querySelector(".shop-menu-toggle");
      const panel = disclosure.querySelector(".shop-menu");
      let timer;
      let hoverOpened = false;
      const setOpen = (open) => {
        window.clearTimeout(timer);
        trigger.setAttribute("aria-expanded", String(open));
        panel.hidden = !open;
        if (!open) hoverOpened = false;
      };
      const close = () => setOpen(false);
      disclosures.push({ close });
      close();
      trigger.addEventListener(
        "click",
        () => {
          const open =
            hoverOpened || trigger.getAttribute("aria-expanded") !== "true";
          hoverOpened = false;
          disclosures.forEach((entry) => entry.close());
          setOpen(open);
        },
        options,
      );
      disclosure.addEventListener(
        "pointerenter",
        (event) => {
          if (event.pointerType !== "mouse" || mobile.matches) return;
          if (trigger.getAttribute("aria-expanded") !== "true")
            hoverOpened = true;
          setOpen(true);
        },
        options,
      );
      disclosure.addEventListener(
        "pointerleave",
        () => {
          timer = window.setTimeout(() => {
            if (!disclosure.contains(document.activeElement)) close();
          }, 160);
        },
        options,
      );
      disclosure.addEventListener(
        "focusout",
        (event) => {
          if (!disclosure.contains(event.relatedTarget)) close();
        },
        options,
      );
      disclosure.addEventListener(
        "keydown",
        (event) => {
          if (event.key === "Escape" && !panel.hidden) {
            event.preventDefault();
            // On mobile the Escape also reaches the menu, which closes and refocuses its toggle.
            if (!mobile.matches) event.stopPropagation();
            close();
            trigger.focus();
          }
          if (event.key === "ArrowDown" && event.target === trigger) {
            event.preventDefault();
            setOpen(true);
            panel.querySelector("a")?.focus();
          }
        },
        options,
      );
      document.addEventListener(
        "click",
        (event) => {
          if (!disclosure.contains(event.target)) close();
        },
        options,
      );
      controller.signal.addEventListener("abort", () =>
        window.clearTimeout(timer),
      );
    });
    const synchronize = () => {
      const focusedWithin = nav.contains(document.activeElement);
      closeMobile();
      if (mobile.matches && focusedWithin) menuButton.focus();
    };
    mobile.addEventListener("change", synchronize, options);
    document.addEventListener(
      "keydown",
      (event) => {
        if (event.key === "Escape" && mobile.matches && !nav.hidden) {
          event.preventDefault();
          closeMobile(true);
        }
      },
      options,
    );
    // The header bounds the menu, except the search panel inside it (the prototype's sits outside).
    const outsideMenu = (target) =>
      !header.contains(target) || Boolean(target?.closest?.(".search-modal"));
    header.addEventListener(
      "focusout",
      (event) => {
        if (mobile.matches && !nav.hidden && outsideMenu(event.relatedTarget))
          closeMobile();
      },
      options,
    );
    document.addEventListener(
      "click",
      (event) => {
        if (mobile.matches && !nav.hidden && outsideMenu(event.target))
          closeMobile();
      },
      options,
    );
    synchronize();
  }
  const initializeWithin = (root) => {
    if (root.matches?.("[data-sf-header]")) initialize(root);
    root.querySelectorAll("[data-sf-header]").forEach(initialize);
  };
  initializeWithin(document);
  document.addEventListener("shopify:section:load", (event) =>
    initializeWithin(event.target),
  );
  document.addEventListener("shopify:section:unload", (event) => {
    event.target.querySelectorAll("[data-sf-header]").forEach((header) => {
      instances.get(header)?.abort();
      instances.delete(header);
    });
  });
})();
